import { RouteObject } from 'react-router-dom';
import UserFeaturesGuard from '~/guards/UserFeaturesGuard';
import { FeatureFlag, UserRole } from '~/types/company';
import lazyImport from '~/utils/lazyImport';
import { analyticsBillsDashboardPages } from '~/views/analytics/bills-dashboard/routing/analytics-bills-dashboard.routes';
import { analyticsPurchasesPricesDashboardPages } from '~/views/analytics/purchases-prices-dashboard/routing/analytics-purchases-prices-dashboard.routes';
import { analyticsSalesPricesDashboardPages } from '~/views/analytics/sales-prices-dashboard/routing/analytics-sales-prices-dashboard.routes';
import AnalyticsIndexRedirect from './AnalyticsIndexRedirect';

const AnalyticsPurchasesPricesDashboardRoute = lazyImport(
  () => import('~/views/analytics/purchases-prices-dashboard/AnalyticsPurchasesPricesDashboardRoute'),
);
const AnalyticsSalesPricesDashboardRoute = lazyImport(
  () => import('~/views/analytics/sales-prices-dashboard/AnalyticsSalesPricesDashboardRoute'),
);
const AnalyticsBillsDashboardRoute = lazyImport(
  () => import('~/views/analytics/bills-dashboard/AnalyticsBillsDashboardRoute'),
);

export const analyticsRoutes: RouteObject[] = [
  {
    index: true,
    element: <AnalyticsIndexRedirect />,
  },
  {
    path: 'purchases/*',
    element: (
      <UserFeaturesGuard
        requiredFeatures={[FeatureFlag.AnalyticsDashboardsPurchases]}
        whitelistedRoles={[UserRole.ENTREPRENEUR]}
      >
        <AnalyticsPurchasesPricesDashboardRoute />
      </UserFeaturesGuard>
    ),
    children: analyticsPurchasesPricesDashboardPages,
  },
  {
    path: 'sales/*',
    element: (
      <UserFeaturesGuard
        requiredFeatures={[FeatureFlag.AnalyticsDashboardsSales]}
        whitelistedRoles={[UserRole.ENTREPRENEUR]}
      >
        <AnalyticsSalesPricesDashboardRoute />
      </UserFeaturesGuard>
    ),
    children: analyticsSalesPricesDashboardPages,
  },
  {
    path: 'bills/*',
    element: (
      <UserFeaturesGuard
        requiredFeatures={[FeatureFlag.AnalyticsDashboardsBills]}
        whitelistedRoles={[UserRole.ENTREPRENEUR]}
      >
        <AnalyticsBillsDashboardRoute />
      </UserFeaturesGuard>
    ),
    children: analyticsBillsDashboardPages,
  },
  {
    path: '*',
    element: <AnalyticsIndexRedirect />,
  },
];
